import React from 'react';

import CourseCreateContainer from '@src/components/course/create/CourseCreateContainer';

const CourseCreatePage = () => <CourseCreateContainer />;

export default CourseCreatePage;
